// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"DropdownBtn_dropdownMenu__2ZX2k"};